// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum AccountingDocumentsInventoryCheckResult {
  Ok = "OK",
  DifferencesFound = "DIFFERENCES_FOUND",
}
export default AccountingDocumentsInventoryCheckResult;

export function accountingDocumentsInventoryCheckResultToVariant(checkResult: AccountingDocumentsInventoryCheckResult): string {
  switch (checkResult) {
    case AccountingDocumentsInventoryCheckResult.DifferencesFound:
      return "danger";

    case AccountingDocumentsInventoryCheckResult.Ok:
    default:
      return "gray";
  }
}
